import React from 'react';
import cx from 'classnames';
import { FormattedMessage, useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { Button } from 'react-bootstrap';

// Components 
import { PlanAvailableIcon } from '../../Common/Assets/SvgIconComponent/CommonSvgIcon';
import CurrencyConverter from '../../CurrencyConverter/CurrencyConverter';
import ShowDescription from '../../Common/ShowDescription/ShowDescription';

// Helpers / Config
import { photosShow } from '../../../helpers/photosShow';
import { servicePlansUploadDir } from '../../../config';
import messages from '../../../locale/jsonMessages';
import history from '../../../core/history';
import { setPaymentActiveStart } from '../../../actions/paymentState';
import withStyles from 'isomorphic-style-loader/withStyles';
import { getServicePlanValue } from '../../../helpers/GetDynamicItemName/dynamicHomeValue';

import bt from '../../../components/commonStyle.css';
import s from './ServicePlansItems.css';


const ServicePlansItems = (props) => {
    const { data, openChangeModal, userPlansData, mode, openCancelModal } = props;

    const intl = useIntl();
    const dispatch = useDispatch();

    const path = photosShow(servicePlansUploadDir);

    const handleClick = async (id) => {
        if (userPlansData) {
            openChangeModal(id, userPlansData?.id);
        } else {
            await dispatch(setPaymentActiveStart(true));
            history.push(`/users/service-payment/${mode}-${id}`);
        }
    };

    const { planName, description } = getServicePlanValue(data, intl.locale);

    return (
        <div className={cx(s.servicePlanCard, data?.purchaseStatus && s.servicePlanActiveCard)}>

            <div className={s.servicePlanUpperCard}>
                <div className={cx(bt.displayFlex, bt.alignCenter, bt.gap8, bt.spaceBottom3)}>
                    <div className={s.servicePlanImage}>
                        <img src={path + data?.mediaImage} alt={data?.planName} />
                    </div>
                    <div className={cx(bt.displayFlex, bt.alignItemFlexStart, bt.spaceBetween, bt.flexGrow, bt.gap4)}>
                        <p className={cx(bt.commonSmallText20, bt.fontWeightMedium, bt.noMargin)}>{planName}</p>
                        {data?.purchaseStatus && <span className={cx(bt.commonSmallText14, bt.fontWeightMedium, "servicePlanCardActiveBadge")}>
                            {intl.formatMessage(messages.activeLabel)}</span>}
                    </div>
                </div>
                <p className={bt.spaceBottom1}>
                    <span className={cx(bt.commonSmallText24, bt.fontWeightBold)}>
                        <CurrencyConverter
                            amount={data?.purchaseStatus ? userPlansData?.price : data?.price}
                            from={data?.purchaseStatus ? userPlansData?.currency : data?.currency}
                        />
                    </span>
                    <span className={cx(bt.commonSmallText16, 'tertiaryText')}>
                        {" / "}{data?.purchaseStatus ? userPlansData?.duration : data?.duration}{" "}
                        {data?.duration == 1
                            ? intl.formatMessage(messages.month)
                            : intl.formatMessage(messages.monthsLabel)}
                    </span>
                </p>

                <ShowDescription description={description} count={70} />

                <div className={cx(bt.spaceTop3)}>
                    {data?.purchaseStatus ?
                        <Button onClick={(e) => openCancelModal(data?.PurchaseData)} className={cx(bt.btnPrimaryBorder, bt.fullWidth)}>
                            {intl.formatMessage(messages.cancel)}
                        </Button>
                        :
                        <Button onClick={() => handleClick(data?.id)} className={cx(bt.btnPrimary, bt.fullWidth)}>
                            {intl.formatMessage(messages.selectPlanLabel)}
                        </Button>
                    }
                </div>
            </div>

            <div className={s.servicePlanLowerCard}>
                <p className={cx(bt.commonSmallText18, bt.fontWeightMedium, bt.spaceBottom2)}>{intl.formatMessage(messages.benefitsLabel)}:</p>
                {(data?.purchaseStatus ? userPlansData?.serviceFee >= 0 : data?.serviceFee >= 0) && (
                    <p className={cx(bt.commonSmallText14, bt.spaceBottom2, bt.displayFlex, bt.gap6)}>
                        <PlanAvailableIcon />
                        {data?.purchaseStatus ? userPlansData?.serviceFee : data?.serviceFee}% {intl.formatMessage(messages.serviceFee)}
                    </p>
                )}

                {(data?.purchaseStatus ? userPlansData?.serviceAIFeature : data?.aiFeaturesStatus) && (
                    <p className={cx(bt.commonSmallText14, bt.noMargin, bt.displayFlex, bt.gap6)}>
                        <PlanAvailableIcon />
                        <FormattedMessage {...messages.aiFeatureLabel} />
                    </p>
                )}
            </div>
        </div>
    );
};

export default withStyles(bt, s)(ServicePlansItems);

